document.addEventListener("DOMContentLoaded", function () {
  const WISHLIST_KEY = "dawn_wishlist";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  }

  function updateWishlistUI() {
    const countEl = document.getElementById("wishlist-count");
    const iconWrap = document.querySelector(".header__icon--wishlist");
    if (!countEl || !iconWrap) return;

    const count = getWishlist().length;
    countEl.textContent = count;

    if (count > 0) {
      iconWrap.classList.add("has-items");
    } else {
      iconWrap.classList.remove("has-items");
    }
  }

  updateWishlistUI();

  document.querySelectorAll(".wishlist-btn").forEach(button => {
    const product = {
      id: button.dataset.id,
      title: button.dataset.title,
      image: button.dataset.image,
      url: button.dataset.url
    };

    button.addEventListener("click", function () {
      let wishlist = getWishlist();
      if (!wishlist.some(item => item.id === product.id)) {
        wishlist.push(product);
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
      }

      updateWishlistUI();
      window.location.href = "/pages/wishlist";
    });
  });
});
// ================================
// FIX: Wishlist on product cards
// (Does NOT affect product page)
// ================================

document.addEventListener(
  "click",
  function (e) {
    const cardBtn = e.target.closest(".card-wishlist-btn");
    if (!cardBtn) return;

    // Stop Dawn product link redirect
    e.preventDefault();
    e.stopImmediatePropagation();

    const WISHLIST_KEY = "dawn_wishlist";

    const product = {
      id: cardBtn.dataset.id,
      title: cardBtn.dataset.title,
      image: cardBtn.dataset.image,
      url: cardBtn.dataset.url
    };

    let wishlist = [];
    try {
      wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch {
      wishlist = [];
    }

    if (!wishlist.some(item => item.id === product.id)) {
      wishlist.push(product);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    }

    // Visual feedback
    cardBtn.classList.add("active");
    cardBtn.textContent = "♥";

    // Update header count (reuse your logic)
    const countEl = document.getElementById("wishlist-count");
    const iconWrap = document.querySelector(".header__icon--wishlist");
    if (countEl && iconWrap) {
      countEl.textContent = wishlist.length;
      iconWrap.classList.add("has-items");
    }
  },
  true // 👈 CAPTURE PHASE (THIS IS THE KEY)
);
document.querySelectorAll(".card-wishlist-btn").forEach(btn => {
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const WISHLIST_KEY = "dawn_wishlist";

    const product = {
      id: btn.dataset.id,
      title: btn.dataset.title,
      image: btn.dataset.image,
      url: btn.dataset.url
    };

    let wishlist = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];

    if (!wishlist.some(item => item.id === product.id)) {
      wishlist.push(product);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    }

    btn.classList.add("active");
    btn.textContent = "♥";

    const countEl = document.getElementById("wishlist-count");
    const iconWrap = document.querySelector(".header__icon--wishlist");
    if (countEl && iconWrap) {
      countEl.textContent = wishlist.length;
      iconWrap.classList.add("has-items");
    }
  });
});

